function rowsFromCsv(content) {
  const rows = [];
  let row = [],
    cell = "",
    quoted = false,
    closedQuote = false;
  const text = String(content).replace(/^\uFEFF/, "");
  for (let i = 0; i < text.length; i += 1) {
    const char = text[i];
    if (
      !quoted &&
      closedQuote &&
      ![";", "\n", "\r", " ", "\t"].includes(char)
    ) {
      throw new Error("Há conteúdo após o fechamento das aspas no CSV.");
    }
    if (char === '"') {
      if (quoted && text[i + 1] === '"') {
        cell += '"';
        i += 1;
      } else if (quoted || cell === "") {
        closedQuote = quoted;
        quoted = !quoted;
      } else throw new Error("Aspas inválidas no CSV.");
    } else if (char === ";" && !quoted) {
      row.push(cell);
      cell = "";
      closedQuote = false;
    } else if ((char === "\n" || char === "\r") && !quoted) {
      if (char === "\r" && text[i + 1] === "\n") i += 1;
      row.push(cell);
      if (row.some((value) => value.trim())) rows.push(row);
      row = [];
      cell = "";
      closedQuote = false;
    } else cell += char;
  }
  if (quoted) throw new Error("Há um campo com aspas sem fechamento no CSV.");
  row.push(cell);
  if (row.some((value) => value.trim())) rows.push(row);
  return rows;
}

function number(value, name, row, optional = false) {
  const text = String(value ?? "").trim();
  if (!text && optional) return 0;
  let normalized = text;
  if (name === "valor" && /^\d{1,3}(\.\d{3})+$/.test(text)) {
    normalized = text.replace(/\./g, "");
  }
  if (text.includes(","))
    normalized = text.replace(/\./g, "").replace(",", ".");
  if (!/^-?\d+(\.\d+)?$/.test(normalized))
    throw new Error(`Linha ${row}: ${name} inválido.`);
  const result = Number(normalized);
  if (!Number.isFinite(result))
    throw new Error(`Linha ${row}: ${name} inválido.`);
  return result;
}

export function parseRoteirizacaoCsv(content, date) {
  const rows = rowsFromCsv(content);
  if (rows.length < 2) throw new Error("O CSV está vazio ou incompleto.");
  const headers = rows[0].map((value) => value.trim());
  if (
    headers.some((value) => !value) ||
    new Set(headers).size !== headers.length
  )
    throw new Error("O CSV contém cabeçalhos vazios ou repetidos.");
  const required = [
    "pedido",
    "latitudeOrigem",
    "longitudeOrigem",
    "latitudeDestino",
    "longitudeDestino",
  ];
  for (const name of required)
    if (!headers.includes(name))
      throw new Error(`Coluna obrigatória ausente: ${name}.`);
  const seen = new Set();
  return rows.slice(1).map((values, index) => {
    const line = index + 2;
    if (values.length !== headers.length)
      throw new Error(
        `Linha ${line}: quantidade de colunas diferente do cabeçalho.`
      );
    const order = {};
    headers.forEach((header, column) => {
      order[header] = values[column].trim();
    });
    order.data = date;
    order.pedido = number(order.pedido, "pedido", line);
    if (
      !Number.isSafeInteger(order.pedido) ||
      order.pedido <= 0 ||
      order.pedido > 2147483647 ||
      seen.has(order.pedido)
    )
      throw new Error(`Linha ${line}: pedido inválido ou repetido.`);
    seen.add(order.pedido);
    for (const name of required.slice(1)) {
      order[name] = number(order[name], name, line);
      const max = name.startsWith("latitude") ? 90 : 180;
      if (Math.abs(order[name]) > max)
        throw new Error(`Linha ${line}: ${name} fora do intervalo válido.`);
    }
    for (const name of [
      "valor",
      "metrosCubicos",
      "tempoMedioAtendimentoMinutosOrigem",
      "tempoMedioAtendimentoMinutosDestino",
    ]) {
      order[name] = number(order[name], name, line, true);
      if (order[name] < 0)
        throw new Error(`Linha ${line}: ${name} deve ser positivo ou zero.`);
    }
    if (Math.abs(order.valor * 100 - Math.round(order.valor * 100)) > 0.00001)
      throw new Error(
        `Linha ${line}: valor deve ter no máximo duas casas decimais.`
      );
    for (const name of [
      "tempoMedioAtendimentoMinutosOrigem",
      "tempoMedioAtendimentoMinutosDestino",
    ]) {
      if (!Number.isInteger(order[name]))
        throw new Error(`Linha ${line}: ${name} deve ser inteiro.`);
    }
    for (const name of ["diaOrigem", "diaDestino"]) {
      order[name] = number(order[name], name, line, true);
      if (
        !Number.isInteger(order[name]) ||
        order[name] < 0 ||
        order[name] > 1
      ) {
        throw new Error(`Linha ${line}: ${name} deve ser 0 ou 1.`);
      }
    }
    for (const name of [
      "janelaInicioOrigem",
      "janelaFimOrigem",
      "janelaInicioDestino",
      "janelaFimDestino",
    ]) {
      if (!order[name]) {
        order[name] = null;
        continue;
      }
      if (!/^([01]\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/.test(order[name]))
        throw new Error(`Linha ${line}: ${name} deve usar HH:mm ou HH:mm:ss.`);
      if (order[name].length === 5) order[name] += ":00";
    }
    return order;
  });
}
